var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardHolderNameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.129,
    height: 31.477,
    viewBox: "0 0 37.129 31.477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "id",
    transform: "translate(-4 -8.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11754",
    "data-name": "Path 11754",
    d: "M22.829,16.6H33.6a2.066,2.066,0,0,0,2.069-2.062V13.128A2.071,2.071,0,0,0,33.6,11.059H31.62a3.48,3.48,0,0,0-6.816,0H22.829a2.071,2.071,0,0,0-2.069,2.069v1.406A2.066,2.066,0,0,0,22.829,16.6Z",
    transform: "translate(-5.648)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11755",
    "data-name": "Path 11755",
    d: "M38.357,15.65H31.343v1.366A3.4,3.4,0,0,1,27.948,20.4H17.181a3.4,3.4,0,0,1-3.395-3.388V15.65H6.771A2.769,2.769,0,0,0,4,18.415V39.479a2.769,2.769,0,0,0,2.771,2.765H38.357a2.769,2.769,0,0,0,2.771-2.765V18.415a2.769,2.769,0,0,0-2.771-2.765ZM19.945,36.429A2.647,2.647,0,0,1,17.5,38.02h-6.4a2.689,2.689,0,0,1-2-4.462,6.7,6.7,0,0,1,2.685-1.79,4.008,4.008,0,1,1,5.019,0c1.871.677,4.146,2.453,3.143,4.661Zm16.111.186H24.812a.663.663,0,1,1,0-1.326H36.057a.663.663,0,1,1,0,1.326Zm0-4.628H24.812a.663.663,0,1,1,0-1.326H36.057a.663.663,0,1,1,0,1.326Zm0-4.621H24.812a.663.663,0,1,1,0-1.326H36.057a.663.663,0,1,1,0,1.326Z",
    transform: "translate(0 -2.482)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11756",
    "data-name": "Path 11756",
    d: "M17.222,41.3c-1.639-.065-5.171,1.25-4.442,3.229a1.331,1.331,0,0,0,1.24.809h6.4a1.315,1.315,0,0,0,1.233-.809C22.413,42.578,18.843,41.218,17.222,41.3Z",
    transform: "translate(-2.926 -11.124)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11757",
    "data-name": "Path 11757",
    d: "M18.165,36.57a2.685,2.685,0,1,0-2.685-2.685,2.685,2.685,0,0,0,2.685,2.685Z",
    transform: "translate(-3.869 -7.723)",
    fill: "#df9426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardHolderNameIcon);
export default __webpack_public_path__ + "static/media/card_holder_name_icon.c62410341411d3b0d545f11211aba525.svg";
export { ForwardRef as ReactComponent };